//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

import { axiosGet } from '../../axios/axios.js'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import { createFieldConfig } from '../../components/QSelectUtils.js'
import { formatConfiguredTime } from '../../components/helpers.js'

export default {
  name: 'ReportProjectField',
  components: {
    ItemsSearchField
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    namedLabel: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      searchConfig: createFieldConfig({ allRecordsFn: this.getAvailableValues }),
      validationAction: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    projectValue: {
      get: function () {
        return this.report.project ? [this.report.project] : null
      },
      set: function (value) {
        const project = value && value.length ? value[0] : null
        this.report.project = project
        this.$emit('change', project)
      }
    },
    required: function () {
      return this.isRequired()
    }
  },
  methods: {
    isRequired: function () {
      if (!this.report.actionsAccess) {
        console.error('Не выполнено преобразование отчёта')
        return false
      }
      const requiredOnActions = this.report.actionsAccess['validation.project.required']
      if (requiredOnActions) {
        if (requiredOnActions.includes('save')) {
          return true
        }
        if (this.validationAction && requiredOnActions.includes(this.validationAction)) {
          return true
        }
      }
      return false
    },
    validate: function (action) {
      this.validationAction = action // PR7, save
      this.$nextTick(() => {
        return this.$refs.field.validate()
      })

      if (this.isRequired() && this.projectValue == null) {
        return false
      }
      return true
    },
    getAvailableValues: function () {
      return axiosGet({
        url: '/service/delta/report/getAvailableProjects?id=' + this.report.id + (this.user.hasRole('reportchecker') || this.$d_hasFullAccess() ? '&useServiceObject=true' : ''),
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения доступных для выбора проектов'
      })
    },
    getProjectStatusColor: function (project) {
      if (project.status !== 'Используется' || project.useStatus !== 'Исполняется' || project.endDate && project.endDate < Date.now()) {
        return 'red'
      } else {
        return 'green'
      }
    },
    getProjectStatusText: function (project) {
      const result = []
      if (project.status) {
        result.push(project.status)
      }
      if (project.useStatus) {
        result.push(project.useStatus)
      }
      if (project.endDate) {
        result.push(formatConfiguredTime(project.endDate, { year: true, month: true, date: true }))
      }
      return result.join(', ')
    }
  }
}

